export const ChangedItemCauseEnum = {
  LowQuantity: 1,
  NotPurchasable: 2,
};
